module.exports = __webpack_public_path__ + "static/media/POAP-201-badge.0b92c768.svg";